export default __webpack_public_path__ + "static/media/edit.6060eff7.svg";